/* unplugin-vue-components disabled */import { render } from "./member_new_pc.vue?vue&type=template&id=9b27f098&scoped=true"
import script from "./member_new_pc.vue?vue&type=script&lang=js"
export * from "./member_new_pc.vue?vue&type=script&lang=js"

import "./member_new_pc.vue?vue&type=style&index=0&id=9b27f098&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b27f098"]])

export default __exports__